import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { appStore, traceStore } from "@/hooks";
import TraceLinkApproval from "./TraceLinkApproval.vue";


/**
 * Displays buttons for the selected trace link.
 */
const __default__ = {
  name: "TraceLinkButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const traceLink = computed(() => traceStore.selectedTraceLink);

/**
 * Closes this panel.
 */
function handleClose(): void {
  appStore.closeSidePanels();
}

return (_ctx: any,_cache: any) => {
  return (traceLink.value)
    ? (_openBlock(), _createBlock(TraceLinkApproval, {
        key: 0,
        trace: traceLink.value,
        deletable: "",
        onApprove: handleClose,
        onDecline: handleClose,
        onUnreview: handleClose,
        onDelete: handleClose
      }, null, 8, ["trace"]))
    : _createCommentVNode("", true)
}
}

})